import React from 'react';
// We only import ReactDOM for @axe-core/react for development mode
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import AppProviders from './AppProviders';
import './index.scss';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import RoleAssignment from './features/role-assignment/RoleAssignment';
import { QueryClient } from '@tanstack/react-query'

const queryClient = new QueryClient()
const rootElement = document.getElementById('root');
const root = createRoot(rootElement as Element);

const router = createBrowserRouter([
  {
    path: '/',
    element: <RoleAssignment />
  },
  {
    path: "/parentOrg/:parentOrgId/loan/:loanId",
    element: <RoleAssignment />
  }
])

// load providers so they are available in the App
export function AppContainer() {
  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
}

if (process.env.NODE_ENV !== 'production') {
  // Warning! @axe-core/react may not support all features of React 18
  // See https://github.com/dequelabs/axe-core-npm/issues/500
  import('@axe-core/react').then((axe) => {
    // Results will show in the DevTools console
    axe.default(React, ReactDOM, 1000);
    root.render(<AppContainer />);
  });
} else {
  root.render(<AppContainer />);
}
